import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ChevronLeft, Users, Plus, Flame, UserPlus, MessageCircle } from "lucide-react";
import PhoneFrame from "../components/PhoneFrame.jsx";
import api from "../lib/api.js";

export default function Community() {
  const nav = useNavigate();
  const [feed, setFeed] = useState([]);
  const [circles, setCircles] = useState([]);
  const [newCircle, setNewCircle] = useState("");

  const load = async () => {
    const [f, c] = await Promise.all([api.get("/community/feed"), api.get("/community/circles")]);
    setFeed(f.data); setCircles(c.data);
  };
  useEffect(() => { load(); }, []);

  const createCircle = async () => {
    if (!newCircle.trim()) return;
    await api.post("/community/circles", { name: newCircle, description: "Small accountability group." });
    setNewCircle(""); toast.success("Circle created"); load();
  };

  return (
    <PhoneFrame>
      <div className="px-5 pt-6 pb-28">
        <button onClick={() => nav(-1)} className="text-slate-400 inline-flex items-center gap-1 text-sm" data-testid="community-back">
          <ChevronLeft size={16} /> Back
        </button>
        <h1 className="ps-heading text-3xl font-bold mt-4">Community</h1>
        <p className="text-slate-400 text-sm">Friends, circles and accountability.</p>

        <div className="mt-5 grid grid-cols-2 gap-3">
          <Link to="/friends" data-testid="community-to-friends" className="ps-card-elev p-4 flex items-center gap-3 hover:border-[#2fbf71]/40">
            <div className="w-10 h-10 rounded-2xl bg-[#0e1d2a] flex items-center justify-center" style={{ boxShadow: "0 0 0 1px #2fbf7133" }}>
              <UserPlus size={18} color="#2fbf71" />
            </div>
            <div className="font-semibold text-sm">Friends</div>
          </Link>
          <Link to="/messages" data-testid="community-to-messages" className="ps-card-elev p-4 flex items-center gap-3 hover:border-[#2fbf71]/40">
            <div className="w-10 h-10 rounded-2xl bg-[#0e1d2a] flex items-center justify-center" style={{ boxShadow: "0 0 0 1px #00B4D833" }}>
              <MessageCircle size={18} color="#00B4D8" />
            </div>
            <div className="font-semibold text-sm">Messages</div>
          </Link>
        </div>

        <div className="mt-6">
          <div className="text-xs uppercase tracking-widest text-slate-400 font-bold mb-3">Posture Circles™</div>
          <div className="flex gap-2">
            <input
              data-testid="circle-name-input"
              value={newCircle} onChange={(e) => setNewCircle(e.target.value)}
              placeholder="Name your circle"
              className="flex-1 bg-[#142534] border border-[#1a2f40] rounded-xl px-4 py-3 text-sm outline-none focus:border-[#2fbf71]"
            />
            <button data-testid="circle-create" onClick={createCircle} className="ps-button-primary px-4 inline-flex items-center gap-1"><Plus size={16} />Create</button>
          </div>
          <div className="mt-4 space-y-2">
            {circles.length === 0 && <div className="text-slate-500 text-sm">No circles yet. Create the first one!</div>}
            {circles.map((c) => (
              <Link
                key={c.id}
                to={`/circles/${c.id}`}
                data-testid={`circle-${c.id}`}
                className="ps-card p-4 flex items-center gap-3"
              >
                <Users size={18} color="#2fbf71" />
                <div className="flex-1">
                  <div className="font-semibold">{c.name}</div>
                  <div className="text-xs text-slate-400">{c.members.length} members</div>
                </div>
                <MessageCircle size={14} className="text-slate-500" />
              </Link>
            ))}
          </div>
        </div>

        <div className="mt-8">
          <div className="text-xs uppercase tracking-widest text-slate-400 font-bold mb-3">Wellness Feed</div>
          <div className="space-y-2">
            {feed.map((u) => (
              <div key={u.user_id} className="ps-card p-4 flex items-center gap-3" data-testid={`feed-${u.user_id}`}>
                <div className="w-10 h-10 rounded-full bg-[#142534] flex items-center justify-center font-bold">{u.name?.[0]}</div>
                <div className="flex-1">
                  <div className="font-semibold">{u.name}</div>
                  <div className="text-xs text-slate-400 inline-flex items-center gap-1">
                    <Flame size={10} color="#F59E0B" /> {u.streak}d streak · {u.points} pts
                  </div>
                </div>
                <button className="text-xs px-3 py-1.5 rounded-full border border-[#1a2f40] text-slate-300">Add</button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </PhoneFrame>
  );
}
